var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import { GET_SUBSCRIPTIONS, GET_SUBSCRIPTIONS_SUCCESS, GET_SUBSCRIPTIONS_ERROR, GET_SUBSCRIPTION, GET_SUBSCRIPTION_SUCCESS, GET_SUBSCRIPTION_ERROR, GET_SUBSCRIPTION_NEWSLETTERS, GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS, GET_SUBSCRIPTION_NEWSLETTERS_ERROR } from "../../constants/actionTypes";
import selectn from "selectn";

var initialState = {
  isLoading: false,
  isFinished: false,
  isError: false,
  error: null,
  data: null,
  results: []
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case GET_SUBSCRIPTIONS:
    case GET_SUBSCRIPTION_NEWSLETTERS:
      {
        return _extends({}, state, {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null
        });
      }

    //if we're switching to a new subscription, wipe out old data
    case GET_SUBSCRIPTION:
      {
        return {
          isLoading: true,
          isFinished: false,
          isError: false,
          error: null,
          data: null,
          results: []
        };
      }

    case GET_SUBSCRIPTION_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: _extends({}, state.data, action.payload)
        });
      }

    case GET_SUBSCRIPTIONS_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          results: action.payload
        });
      }

    case GET_SUBSCRIPTION_NEWSLETTERS_SUCCESS:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          data: _extends({}, state.data, {
            subscription_newsletters: _extends({}, action.payload, {
              results: (selectn("subscription_newsletters.results", state.data) || []).concat(action.payload.results)
            })
          })
        });
      }

    case GET_SUBSCRIPTION_ERROR:
    case GET_SUBSCRIPTIONS_ERROR:
    case GET_SUBSCRIPTION_NEWSLETTERS_ERROR:
      {
        return _extends({}, state, {
          isLoading: false,
          isFinished: true,
          isError: true,
          error: action.payload
        });
      }

    default:
      {
        return state;
      }
  }
});


// WEBPACK FOOTER //
// ./src/subscriptions/reducers/subscriptions.js